import React, { createContext, useState, useEffect, useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { toast } from 'react-toastify';

const StripeContext = createContext(null);

export const StripeProvider = ({ children }) => {
  const [stripePromise, setStripePromise] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initialize = async () => {
      try {
        const stripeInstance = await loadStripe(
          process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
        );
        setStripePromise(stripeInstance);
      } catch (err) {
        setError(err);
        toast.error(
          'We encountered an issue initializing the payment system. Some payment features may not work properly.',
          {
            position: 'top-center',
            autoClose: false,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            style: { height: '120px' },
          },
        );
      } finally {
        setLoading(false);
      }
    };

    initialize();
  }, []);

  return (
    <StripeContext.Provider value={{ stripePromise, loading, error }}>
      {children}
    </StripeContext.Provider>
  );
};

export const useStripe = () => {
  return useContext(StripeContext);
};
